import service from "@/store/services/cash-register-readings-service";

export const state = () => ({
  list: {},
  cashRegisterReading: {},
  meta: {},
  url: null,
  recordSales: [],
  recordSalesMeta: {},
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, cashRegisterReading) => {
    state.cashRegisterReading = cashRegisterReading;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  },
  SET_RECORD_SALES: (state, records) => {
    state.recordSales = records;
  },
  SET_RECORD_SALES_META: (state, meta) => {
    state.recordSalesMeta = meta;
  },
};

export const actions = {
  list({ commit, dispatch }, params = {}) {
    return service.list(params, this.$axios).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params, this.$axios).then((cashRegisterReading) => {
      commit("SET_RESOURCE", cashRegisterReading);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params, this.$axios).then((cashRegisterReading) => {
      commit("SET_RESOURCE", cashRegisterReading);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params, this.$axios).then((cashRegisterReading) => {
      commit("SET_RESOURCE", cashRegisterReading);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params, this.$axios);
  },

  validate({ commit, dispatch }, params) {
    return service.validate(params, this.$axios).then((cashRegisterReading) => {
      commit("SET_RESOURCE", cashRegisterReading);
    });
  },

  cancel({ commit, dispatch }, params) {
    return service.cancel(params, this.$axios).then((cashRegisterReading) => {
      commit("SET_RESOURCE", cashRegisterReading);
    });
  },

  print({ commit, dispatch }, params) {
    return service.print(params, this.$axios);
  },

  istheraReadingPreview(context, params) {
    return service.istheraReadingPreview(params);
  },

  istheraPrefill(context, id) {
    return service.istheraPrefill(id);
  },

  recordSales({ commit }, params = {}) {
    return service.recordSales(params).then(({ records, meta }) => {
      commit("SET_RECORD_SALES", records);
      commit("SET_RECORD_SALES_META", meta);
      return records;
    });
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page.total,
  cashRegisterReading: (state) => state.cashRegisterReading,
  url: (state) => state.url,
  recordSales: (state) => state.recordSales,
  recordSalesMeta: (state) => state.recordSalesMeta,
  dropdown: (state) => {
    return state.list.map((cashRegisterReading) => ({
      id: cashRegisterReading.id,
      name: `${cashRegisterReading.code} ${cashRegisterReading.name}`,
    }));
  },
};

const cashRegisterReadings = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default cashRegisterReadings;
